import { isTrustedRoutesUrl } from '@utils/validateUrl.utils';
import { LinkProps } from 'next/link';
import NextLink from 'next/link';

export function Link({
  url,
  ...props
}: Omit<LinkProps, 'href'> & {
  url: string;
  children: React.ReactNode;
  query?: Record<string, string>;
  target?: string;
  className?: string;
  rel?: string;
}) {
  if (!url) return <>{props.children}</>;
  if (props.target === '_blank') {
    const relTokens = new Set(
      `${props.rel ?? ''} noopener noreferrer`.split(/\s+/).filter(Boolean)
    );
    props = { ...props, rel: Array.from(relTokens).join(' ') };
  }
  const { trusted, url: href } = isTrustedRoutesUrl(url);
  if (trusted)
    return (
      <NextLink
        href={props.query ? { pathname: href, query: props.query } : href}
        {...props}
      />
    );
  return (
    <NextLink
      href={props.query ? { pathname: url, query: props.query } : url}
      {...props}
    />
  );
}
